import { defineComponent as ne, mergeModels as H, useSlots as le, ref as a, useModel as ae, computed as p, useAttrs as re, watchEffect as ie, watch as T, onMounted as oe, onBeforeUnmount as ue, createElementBlock as S, createCommentVNode as E, openBlock as L, mergeProps as se, toHandlers as ce, createElementVNode as c, createVNode as v, createTextVNode as ve, toDisplayString as O, normalizeClass as R, unref as I } from "vue";
import { useResizeObserver as fe } from "@vueuse/core";
import { RevButtonIcon as j } from "@ds/components/ButtonIcon";
import me from "../../icons/generated/IconChevronLeft.vue2.js";
import de from "../../icons/generated/IconChevronRight.vue2.js";
import { track as xe } from "@ds/tracking/tracking";
import { isBrowser as he } from "../../utils/client.js";
import { isEmpty as be } from "../../utils/isEmpty.js";
import { tw as X } from "../../utils/tailwind.js";
import { skipFragment as pe, isVNodeEmpty as ye } from "../../utils/vnode.js";
import ge from "../CardCarousel/components/CardCarouselController.vue2.js";
import { INTERVAL_IN_MILLISECOND as ke } from "./Carousel.constant.js";
import Y from "./components/CarouselController.vue2.js";
import Ie from "./components/CarouselItems.vue2.js";
const Ce = { class: "relative flex w-full grow justify-center" }, we = {
  class: "sr-only",
  role: "status"
}, Ne = ["aria-labelledby"], Te = {
  key: 0,
  class: "mx-auto mt-16 flex w-full max-w-[1072px] items-center px-12"
}, He = /* @__PURE__ */ ne({
  name: "RevCarousel",
  inheritAttrs: !1,
  __name: "Carousel",
  props: /* @__PURE__ */ H({
    alternativeButtonLabel: {},
    alternativeNext: {},
    alternativePrevious: {},
    tracking: { default: null },
    thumbnails: { default: () => {
    } },
    autoplay: { type: Boolean, default: !1 },
    interval: { default: () => ke },
    currentIndexId: {}
  }, {
    currentIndex: {
      default: 0
    },
    currentIndexModifiers: {}
  }),
  emits: /* @__PURE__ */ H(["slide-impression", "next-button-click", "prev-button-click", "navigation-click", "swipe"], ["update:currentIndex"]),
  setup(t, { emit: F }) {
    const q = le(), f = F, C = a(null), y = a(void 0), m = a(null), d = a(null), n = ae(t, "currentIndex"), g = a(0), k = a(0), x = a(!1), h = a(t.autoplay), B = a(0), M = p(
      () => pe(q?.default({})).filter(
        (e) => !ye(e)
      )
    ), r = p(() => M.value.length), W = p(() => !be(t.thumbnails)), G = re();
    function P(e) {
      const l = e ?? n.value;
      f("slide-impression", { index: l }), xe({
        action: "carousel-impression",
        context: {
          ...G,
          ...t.tracking,
          currentSlide: l
        }
      });
    }
    const b = a(!1), w = a(0);
    function z() {
      const e = m.value instanceof HTMLElement ? m.value.offsetWidth : 0, l = y.value instanceof HTMLElement ? y.value.offsetWidth : 48, i = a(0);
      w.value === 0 ? (i.value = C.value instanceof HTMLElement ? C.value.offsetWidth : 0, w.value = i.value) : i.value = w.value;
      const u = e - l * 2;
      return i.value > u;
    }
    function J() {
      n.value >= r.value - 1 ? n.value = 0 : n.value += 1;
    }
    function K() {
      n.value === 0 ? n.value = r.value - 1 : n.value -= 1;
    }
    function Q(e) {
      e !== n.value && (n.value = e);
    }
    function s(e) {
      x.value && (h.value = !1), typeof e == "number" && Q(e), e === "previous" && K(), e === "next" && J();
    }
    function D(e) {
      const l = e.touches[0];
      g.value = l.clientX, k.value = l.clientY;
    }
    function V(e) {
      if (!g.value || !k.value)
        return;
      const l = e.touches[0].clientX, i = e.touches[0].clientY, u = g.value - l, N = k.value - i;
      Math.abs(u) > Math.abs(N) && (f("swipe"), u > 0 ? s("next") : s("previous")), g.value = 0, k.value = 0;
    }
    const Z = p(() => [
      b.value && X`absolute left-0 z-10 mt-4`
    ]), _ = p(() => [
      b.value && X`absolute right-0 z-10 mt-4`
    ]), ee = ie((e) => {
      if (h.value && he()) {
        let l = 0;
        const i = setInterval(() => {
          x.value || (s("next"), l = 0);
        }, t.interval), u = 50, N = setInterval(() => {
          l += u, x.value || (B.value = l / t.interval);
        }, u);
        e(() => {
          clearInterval(i), clearInterval(N);
        });
      }
    });
    function o(e) {
      x.value = e;
    }
    function $() {
      o(!0), f("next-button-click"), s("next");
    }
    function A() {
      o(!0), f("prev-button-click"), s("previous");
    }
    function U(e) {
      o(!0), f("navigation-click"), s(e);
    }
    function te(e) {
      if (e === "forward") {
        $();
        return;
      }
      A();
    }
    return T(
      () => t.autoplay,
      async (e) => {
        h.value = e;
      },
      { immediate: !0 }
    ), T(
      () => m.value,
      () => {
        b.value = z(), fe(m, () => {
          b.value = z();
        });
      }
    ), T(
      () => n.value,
      (e) => {
        x.value && (h.value = !1), P(e);
      }
    ), oe(() => {
      d.value?.addEventListener("touchmove", V, !1), d.value?.addEventListener("touchstart", D, !1), P();
    }), ue(() => {
      d.value?.removeEventListener("touchstart", D, !1), d.value?.removeEventListener("touchmove", V, !1), ee();
    }), (e, l) => r.value ? (L(), S("div", se({
      key: 0,
      ref_key: "carousel",
      ref: d,
      class: ["relative -mb-4 flex min-h-72 flex-col flex-wrap overflow-hidden", [e.$attrs.class, t.thumbnails?.length ?? "pb-4"]]
    }, ce({
      focusin: () => o(!0),
      focusout: () => o(!1),
      mouseout: () => o(!1),
      mouseover: () => o(!0)
    }, !0)), [
      c("div", Ce, [
        v(Ie, {
          "current-index": n.value,
          "current-index-id": t.currentIndexId,
          items: M.value
        }, null, 8, ["current-index", "current-index-id", "items"]),
        c("div", we, [
          ve(O(n.value + 1) + " / " + O(r.value) + ". ", 1),
          c("span", { "aria-labelledby": t.currentIndexId }, null, 8, Ne)
        ])
      ]),
      !W.value && r.value > 1 ? (L(), S("div", Te, [
        v(Y, {
          "autoplay-running": h.value,
          "button-aria-label": t.alternativeButtonLabel,
          class: "mx-auto md:mx-0",
          "current-index": n.value,
          "image-count": r.value,
          "interval-progression": B.value,
          onSelect: U
        }, null, 8, ["autoplay-running", "button-aria-label", "current-index", "image-count", "interval-progression"]),
        v(ge, {
          "can-scroll-next": !0,
          "can-scroll-prev": !0,
          class: "ml-auto hidden md:block",
          "next-alternative-text": t.alternativeNext,
          "prev-alternative-text": t.alternativePrevious,
          onScroll: te
        }, null, 8, ["next-alternative-text", "prev-alternative-text"])
      ])) : E("", !0),
      W.value && r.value > 1 ? (L(), S("div", {
        key: 1,
        ref_key: "controllerContainerRef",
        ref: m,
        class: R(["relative isolate mx-auto flex w-full justify-center pt-12", { "h-60": t.thumbnails }])
      }, [
        c("div", {
          ref_key: "prevButtonRef",
          ref: y,
          class: R(["flex items-center px-8 py-4", Z.value])
        }, [
          v(I(j), {
            "alternative-text": t.alternativePrevious,
            icon: I(me),
            size: "small",
            type: "button",
            variant: "primary",
            onClick: A
          }, null, 8, ["alternative-text", "icon"])
        ], 2),
        c("div", {
          ref_key: "controllerWrapperRef",
          ref: C
        }, [
          v(Y, {
            "button-aria-label": t.alternativeButtonLabel,
            "current-index": n.value,
            "image-count": r.value,
            "prev-button-ref": y.value,
            "should-thumbnails-scroll": b.value,
            thumbnails: t.thumbnails,
            onSelect: U
          }, null, 8, ["button-aria-label", "current-index", "image-count", "prev-button-ref", "should-thumbnails-scroll", "thumbnails"])
        ], 512),
        c("div", {
          class: R(["flex items-center px-8 py-4", _.value])
        }, [
          v(I(j), {
            "alternative-text": t.alternativeNext,
            icon: I(de),
            size: "small",
            type: "button",
            variant: "primary",
            onClick: $
          }, null, 8, ["alternative-text", "icon"])
        ], 2)
      ], 2)) : E("", !0)
    ], 16)) : E("", !0);
  }
});
export {
  He as default
};
